import { render, staticRenderFns } from "./SystemBarTopTrial.vue?vue&type=template&id=5b4bb36e"
import script from "./SystemBarTopTrial.vue?vue&type=script&lang=js"
export * from "./SystemBarTopTrial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports